import Service from "../../Service";

const resource = "visit/";

export default {
    
    save(parameters, requestID) {
        return Service.post(resource + "savePhytosanitaryEvaluation", parameters, {
            params: {
                requestID: requestID,
            },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "paginationPhytosanitaryEvaluation", parameters, {
            params: { requestID }
        });
    }
};